import {useFetchData} from 'hooks/api/useFetchData'
import {Status} from 'types/api/publicApiOAuth/status'

export const useFetchPublicApiOAuthStatus = () => {
  const path = '/api/public-api-oauth/status'
  return useFetchData<Status>(path, {}, {})
}
